import { Navigate, createFileRoute } from "@tanstack/react-router";
import { OnboardingQueue } from "../components/admin/onboarding-queue";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/onboarding/")({
  component: AdminOnboardingPage,
});

function AdminOnboardingPage() {
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return <OnboardingQueue />;
}
